// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import cstmTable from '../../../share/components/vue/PaginationTable';
import config from '../../../share/config';
import individualDiagnose from '../../../share/util/individualDiagnose';
import api from '../../../common/api';
import apiService from '../../../../../share/src/util/api/service';
import { executeSyncRequest } from '../../../../../share/src/util/api/syncRequest';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_IN_PROGRESS, REQUEST_STATUS_FAILED, executePolling } from '../../../../../share/src/util/api/polling';
import logWrapper from '../../../share/logWrapper';
import handler from '../../../share/util/apiResultValidator';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import memoPage from '../../vue/MemoPage';
import resource from '../../../share/util/resourceMap';
import vehicle from '../../../share/util/vehicle';
import util from '../../../share/util/utils';
import cstmCard from "../../../share/components/vue/CustomCard";
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';
import diagnoseResource from '../../../share/util/diagnose';
import { readSetDestination, writeSetDestination } from './destinationServices';
import { fetchMasterMirrorCustomizeHistories } from '../../../services/customize/fetchHistoriesService';
import { deleteCustomizeHistory } from '../../../services/customize/deleteHistoryService';
import { getAbbrSysName } from '../../../share/util/systemName';
const DiagSystemUtils = require('../../../common/nodejs/diagSystemUtils');

const VEHICLE_INFO_GET = "get";
const VEHICLE_INIT = "init";
const SAVE_SETTINGS = "saveSettings";
const VEHICLE_UPDATE = "update";
const VEHICLE_UPDATE_PART = "update_part";
const VEHICLE_UPDATE_COMMUNICATION = "update_communication";
const VEHICLE_DELETE_HISTORY = "delete_history";
const VEHICLE_READ_HISTORY = "read_history";
const VEHICLE_DESTINATION_GET = "destination_get";
const VEHICLE_DESTINATION_SAVE = "destination_save";
const VEHICLE_DESTINATION_SUPPORT_IDS = "destination_support_ids";

// 検索条件
const SEARCH_YEAR_RANGE = 10;
const SEARCH_MONTH_RANGE = 12;

// 仕向地設定のphase定義
const DESTINATION_PHASE = {
  RECONFIRMATION: "reconfirmation",
  CONFIRMATION: "confirmation",
  INPUT_CODE: "inputCode"
};

// 仕向地設定のtype設定
const DESTINATION_TYPE = {
  READ: 'read_destination',
  WRITE: 'update_destination',
  READ_MENU: 'read_menu_list',
  SUPPORT_DID: 'read_support_did',
};

// 仕向地設定のREAD正常終了時の遷移先定義
const TRANSITION = {
  TRANSITION_GET_INFORMATION: 'transition_get_information',
  TRANSITION_CONFIRMATION: 'transition_confirmation'
};

export default {
  name: "individualCustomize",
  data() {
    return {
      processing: false,
      measuredId: null,
      cstmListItem: [],
      cstmDataResponse: null,
      isUseCache: true,
      isLoading: false,
      currentDate: null,
      vehicleDisplayInfo: {
        vin: '',
        specMode: '',
        spec: '',
        model: '',
        appliedModel: '',
        modelDisplayName: '',
        registrationNumber: '',
        hideRegistrationNumber: true,
      },
      description: '',
      customReadTable: [],
      customReadTablePre: [],
      selectedYear: '',
      selectedMonth: '',
      searchYearOptions: [''],
      searchMonthOptions: [''],
      filledComment: '',
      isSearchFieldOpened: true,
      selectedCustomRead: {},
      modalMemo: false,
      modalCustomRead: false,
      modalSettingsSave: false,
      isMemoDialogLoading: false,
      showSetDestination: false,
      setDestinationPhase: DESTINATION_PHASE.CONFIRMATION,
      validateParam: undefined,
      currentDestination: '',
      confirmationDestination: '',
      reconfirmationDestination: '',
      inputDestinationCode: '',
      tmpRequestId: ''
    };
  },

  props: {
    // noop
  },

  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
    'memo-Page': memoPage,
    'cstm-card': cstmCard
  },

  watch: {
    language: {
      handler(val) {
        val; // To avoid warning
        if (!this.cstmDataResponse) {
          return;
        }
        const systemId = individualDiagnose.getCurrentSystemId(this);
        this.cstmListItem = resource.getCstmSaveOrderTable(this.cstmDataResponse, systemId, this.cstmListItem, this);
        // 設定保存・設定読み出しダイアログ_車両情報の取得
        this.getVehicleInfoForSaveSettings();
      }
    }
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      vehicleModelDisplayNameList: state => state.masterResources.vehicleModelDisplayNameList,
      userInfo: state => state.userProperty.userInfo,
      isPopstateNavigation: state => state.cache.isPopstateNavigation,
    }),
    /**
     * カスタムテーブルのcolumn定義
     */
    cstmTableColumns() {
      return [
        { name: 'name', label: 'individual.header_customize_name', useSort: true },
        { name: 'currentValue', label: 'individual.header_customize_current_setting', useSort: true },
        { name: 'writeSettings', label: 'individual.header_customize_write_settings', usePulldown: true },
        { name: 'result', label: 'individual.header_customize_result', useResource: true, useSort: true },
        { name: 'description', label: 'individual.common_label_description', useSort: true }
      ];
    },
    /**
     * システム用のリソースキーを取得する
     * @returns リソースキー
     */
    getSystemResourceKey() {
      const selectedSystemId = individualDiagnose.getCurrentSystemId(this);
      return resource.getResourceKeyForDiagSystem(selectedSystemId);
    },

    /**
     * 設定読出しテーブルcolumn
     */
    customReadTableColumns() {
      return [
        { name: 'registered_at', label: 'message.label_measured_data_details_registered_date' },
        { name: 'description', label: 'individual.common_label_description' },
        { name: 'deleteBtn', label: 'individual.label_readiness_code_delete', useButton: true },
      ];
    },

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoseResource.operationFrom(this.$router.currentRoute.value.name);
    },

    /**
     * 仕向地設定モーダルのヘッダタイトル
     */
    destinationTitle() {
      // 仕向地変更確認画面, 仕向地コード入力画面
      const DestinationTitle = 'individual.header_cst_set_destination';
      // 仕向地設定再確認画面
      const WarningTitle = 'message.common_title_warning';

      const titleMap = {
        confirmation: DestinationTitle,
        inputCode: DestinationTitle,
        reconfirmation: WarningTitle
      };
      return this.$t(titleMap[this.setDestinationPhase]);
    },

    /**
     * 入力欄を表示するかどうか
     */
    showInputForm() {
      const showInputCodeMap = {
        inputCode: true
      };
      let result = showInputCodeMap[this.setDestinationPhase];
      if (typeof result === 'undefined') {
        // 合致しない場合は false とする。
        result = false;
      }
      return result;
    }
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      vm.beforeRouteProcess(vm, from);
    });
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      this.beforeRouteProcess(this, from);
      // テーブル情報クリア（本当は mountedLogic に入れたいが、影響範囲を考慮してここにピンポイントで入れている）
      this.cstmListItem = [];
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('table', ['getCustomizeSystemTable']),
    ...mapActions('observation', ['usageCountUp']),
    ...mapActions('cache', ['cacheIsPopstateNavigation']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // 設定保存ダイアログ_車両情報の取得
      this.getVehicleInfoForSaveSettings();
      // カスタマイズテーブル一覧取得APIの呼び出し
      this.init();

      // 初期の検索条件の設定（現在の年、月）
      const currentYear = new Date().getFullYear();
      this.selectedYear = String(currentYear);
      // 空白(全年検索用)+今年+過去10年を選択できるような選択肢配列を作成
      this.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));

      const currentMonth = new Date().getMonth() + 1;
      this.selectedMonth = String(currentMonth);
      // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
      this.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     * @param {string} action 処理内容
     */
    validateErrorResult(result, action) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(action); },
      );
    },

    /**
     * カスタマイズ一覧の取得を行う
     */
    async init() {
      try {
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        // カスタマイズ一覧取得のポーリング処理を行う
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/initialize',
              {
                use_cache: this.isUseCache
              }
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INIT); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_CSTMS_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_CSTMS_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_CSTMS_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INIT); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INIT); },
        );

        if (response) {
          // 診断システムID略称がボディコントロールユニット（BIU）であるかチェック
          if (DiagSystemUtils.isBodyControlByAbbreviationId(getAbbrSysName(systemId))) {

            // ECUがボディコントロールユニット（BIU）である場合、仕向地設定の処理を実行する
            await this.destinationSettingRead();
          } else {
            // カスタマイズの取得を行う
            await this.getCstmsTable();
          }
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * メモダイアログを表示
     */
    openNoteModal() {
      this.modalMemo = true;
    },

    closeNoteModal() {
      this.modalMemo = false;
    },


    /**
     * メモ情報の保存
     */
    async memoSave() {
      await this.$refs.memo.save();
    },

    /**
     * メモ情報のクリア
     */
    memoClear: function () {
      this.$refs.memo.clear();
    },

    /**
     * 設定保存ボタン押下
     */
    onClickSaveSettings() {
      // 説明入力の初期化
      this.description = '';
      // ダイアログ表示タイミングで、現在日時を取得する
      this.currentDate = util.timeConverter(Date.now(), null, 'min');
      // 設定保存ダイアログの表示
      this.modalSettingsSave = true;
    },

    //再取得ボタン押下時の処理
    regetCstm() {
      const messages = this.$t('individual.message_vehicle_csmt_confirm_get_information');

      const systemId = individualDiagnose.getCurrentSystemId(this);
      alert.showConfirmation(this, null,
        messages,
        async () => {
          // リストを空にしておく
          this.cstmListItem = [];

          // 診断システムID略称がボディコントロールユニット（BIU）であるかチェック
          if (DiagSystemUtils.isBodyControlByAbbreviationId(getAbbrSysName(systemId))) {
            // ECUがボディコントロールユニット（BIU）である場合、仕向地設定の処理を実行する
            await this.destinationSettingRead();
          } else {
            // カスタマイズの取得
            await this.getCstmsTable(true);
          }
        });
    },

    getChangedItemsCount() {
      return this.getChangedItems().length;
    },

    /**
    * カスタマイズ設定変更ボタン活性化の有無
    */
    getChangedItems() {
      return this.cstmListItem.filter(
        // 設定変更されたアイテムのみに絞る
        cstm => cstm.currentValue !== cstm.selectItem
      );
    },

    /**
    * カスタマイズ設定変更ボタン押下時の処理
    */
    updateCstmData() {
      const messages = this.$t('individual.message_confirm_cstm_change_setting');
      // 設定値変更確認ダイアログを表示
      alert.showConfirmation(this, null, messages,
        async () => {
          await this.cstmChangeSetting();
        });
    },

    /**
     * カスタマイズの設定値変更を行う
     */
    async cstmChangeSetting() {
      try {
        // カスタマイズの設定値変更
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        // カスタマイズの設定値変更(要求)（バックエンドAPI_POST）
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/updateSettings',
              this.getRequestBodyUpdateSettings()
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_UPDATE); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_CSTMS_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_CSTMS_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_CSTMS_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_UPDATE); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_UPDATE); },
        );

        if (response) {
          // 正常終了：一覧データ取得処理を行う
          this.measuredId = String(response.data.measured_id);
          this.cstmDataResponse = await this.getCstmList();
          this.cstmListItem = resource.getCstmSaveOrderTable(this.cstmDataResponse, systemId, this.cstmListItem, this);
          const isShowConnectedErrorDialog = this.cstmListItem.find((cstm) => cstm.showConnectedErrorDialog);
          const isShowFailedDialog = this.cstmListItem.find((cstm) => cstm.showFailedDialog);
          if (isShowConnectedErrorDialog) {
            // 一つでも「通信不能」を含む場合、通信エラーを表示する
            this.showUnexpectedError(VEHICLE_UPDATE_COMMUNICATION);
          } else if (isShowFailedDialog) {
            // 一つも「通信不能」が無く、結果に失敗が含まれる場合、専用の書き込みエラーダイアログを表示
            this.showUnexpectedError(VEHICLE_UPDATE_PART);
          } else {
            // 表示項目がない場合、非サポート画面を表示
            if (this.cstmListItem.length < 1) {
              // OK押下時は何もしない
              alert.showConfirmation(this, null, this.$t('individual.label_not_supported_message'), null, null, null, true);
            }
          }
        }
      } finally {
        this.processing = false;
      }
    },

    getRequestBodyUpdateSettings: function () {
      // 現在選択されている値を取得する
      return {
        settings: this.cstmListItem.map(e => ({
          immutable_id: e.immuTableId,
          currentValue: resource.getCstmSettingValue(e.currentValue, e.mapKeyToValue),
          isWriteRequired: e.currentValue === e.selectItem ? false : true,
          updateValue: resource.getCstmSettingValue(e.selectItem, e.mapKeyToValue),
          byte_value: (e.byteValue === undefined || e.byteValue === null) ? null : e.byteValue,
        }))
      };
    },

    /**
     * カスタマイズの取得を行う関数
     * @param {boolean} eventLogHandleIdFlg 再取得から呼ばれた際に true（イベントログの操作 ID 発行する）とする
     */
    async getCstmsTable(eventLogHandleIdFlg = false) {
      try {
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        if (eventLogHandleIdFlg) {
          // イベントログの操作 ID 発行
          await eventLogUtil.createEventLogHandleId(this.netAppId);
        }
        // カスタマイズの取得(要求)（バックエンドAPI_POST）
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/readOutSettings'
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INFO_GET); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_CSTMS_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_CSTMS_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_CSTMS_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
        );

        if (response) {
          // 正常終了：一覧データ取得処理を行う
          this.measuredId = String(response.data.measured_id);
          this.cstmDataResponse = await this.getCstmList();
          this.cstmListItem = resource.getCstmSaveOrderTable(this.cstmDataResponse, systemId, this.cstmListItem, this);
          // 表示項目がない場合、非サポート画面を表示
          if (this.cstmListItem.length < 1) {
            // OK押下時は何もしない
            alert.showConfirmation(this, null, this.$t('individual.label_not_supported_message'), null, null, null, true);
          }
          // カスタマイズの利用回数カウントアップ
          this.usageCountUp({ type: config.USAGE_COUNT_CST, systemName: systemId });
        }
      } finally {
        this.processing = false;
      }
    },

    /**
    * 一覧取得処理を行う関数
    * @returns GetのResponse | null
    */
    async getCstmList() {
      const projectId = this.vehicleInfo.vehicle.project.id;
      // Get APIを呼び出す
      const response = await individualDiagnose.syncApi(
        this,
        async () => {
          return await api.getCall(
            config.CST,
            '/customize/' + projectId + '/' + this.measuredId,
            this.operationScreen
          );
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(VEHICLE_INFO_GET); },
        // GET API で正常レスポンスが返ってきた際の内容チェック
        (getApiResponse) => {
          // data が入っていれば成功とする
          return getApiResponse && getApiResponse.data && getApiResponse.data.projects ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result, VEHICLE_INFO_GET); },
      );
      // 処理失敗時は response が null になるので考慮
      if (response !== null) {
        const resultResponse = response.data.projects;
        this.getCustomizeSystemTable(resultResponse);
        return resultResponse;
      } else {
        return response;
      }
    },

    /**
    * Getのレスポンスのハンドリングを行う
    * @param response GetのResponse
    * @param currentRetry リトライ回数
    * @param retryMaxCount 最大リトライ可能回数
    * @param action 処理内容
    * @returns 処理結果{isCompleted: 終了判定(boolean), response: GetのResponse | null}
    */
    async getResponseHandler(response, currentRetry, retryMaxCount, action) {
      return new Promise((resolve) => {
        handler.validate(handler.validateTypes.all, response, this, null, () => {
          // 正常コールバック
          switch (response.data.status) {
            // 正常終了、異常終了
            case config.STATUS_CSTMS_COMPLETED:
            case config.STATUS_CSTMS_FAILED:
              return resolve({ isCompleted: true, response: response });
            default:
              // in_progress
              if (currentRetry >= retryMaxCount) {
                // リトライ回数上限値に達した場合も処理終了
                // 汎用エラー扱いの為、responseをnullで返す
                this.showUnexpectedError(action);
                return resolve({ isCompleted: true, response: null });
              }
              return resolve({ isCompleted: false, response: null });
          }
        },
          (result) => {
            // 不正応答コールバックが呼び出された場合も処理終了
            const cause = result.causeType;
            const behaviorType = result.behaviorType;
            // セッションが不正・ネットワークエラーならログアウト処理を行う(CC通信は行っていないのでCCエラーは対象外)
            if (cause === handler.causeTypes.networkError ||
              cause === handler.causeTypes.invalidSessionToken) {
              alert.showWarning(this, null, result.message, () => {
                if (behaviorType === handler.behaviorTypes.logout) {
                  this.logout(this);
                } else if (behaviorType === handler.behaviorTypes.resetSession) {
                  this.resetSession(this);
                }
              });
            } else {
              // その他のエラー
              this.showUnexpectedError(action);
            }
            // エラー扱いの為、responseをnullで返す
            resolve({ isCompleted: true, response: null });
            return;
          }, null, false);
      });
    },

    /**
    * その他のエラー発生時の処理を行う
    * @param {string} action 処理内容
    */
    showUnexpectedError(action) {
      let messageKey;
      switch (action) {
        case VEHICLE_INIT:
          messageKey = 'individual.error_Initialize_communication_error';
          break;
        case VEHICLE_INFO_GET:
          messageKey = 'individual.error_cstm_connect_title';
          break;
        case SAVE_SETTINGS:
          messageKey = 'individual.error_cstm_save_settings';
          break;
        case VEHICLE_UPDATE:
          messageKey = 'individual.error_cstm_data_write';
          break;
        case VEHICLE_UPDATE_PART:
          messageKey = 'individual.error_cstm_data_write_part';
          break;
        case VEHICLE_UPDATE_COMMUNICATION:
          messageKey = 'individual.error_communication_error';
          break;
        case VEHICLE_READ_HISTORY:
          messageKey = 'individual.error_cstm_read_settings';
          break;
        case VEHICLE_DELETE_HISTORY:
          messageKey = 'individual.error_cstm_delete_settings';
          break;
        case VEHICLE_DESTINATION_GET:
          messageKey = 'individual.error_cstm_destination_get';
          break;
        case VEHICLE_DESTINATION_SAVE:
          messageKey = 'individual.error_cstm_destination_save';
          break;
        case VEHICLE_DESTINATION_SUPPORT_IDS:
          messageKey = 'individual.error_cstm_support_did';
          break;
      }
      alert.showError(this, null, this.$t(messageKey), () => { });
    },

    /**
     * 設定保存ダイアログ_車両情報の取得
     */
    getVehicleInfoForSaveSettings() {
      // 車両情報の取得
      this.vehicleDisplayInfo = vehicle.formatVehicleInfo(this.vehicleInfo, this.vehicleModelDisplayNameList, this.language);
    },

    /**
     * 設定保存ダイアログ_保存ボタン押下
     */
    async saveSettings() {
      // 設定保存処理
      await this.createSaveSettings();
      // ダイアログを閉じる
      this.modalSettingsSave = false;
    },

    /**
     * 設定保存処理
     */
    async createSaveSettings() {
      try {
        this.isLoading = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        await individualDiagnose.syncApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CST,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/histories',
              {
                description: this.description.trim(),
                setting: this.getSaveSettingsRequestBody()
              }
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(SAVE_SETTINGS); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // ここでのレスポンスチェックは行わない
            postApiResponse;
            return '';
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, SAVE_SETTINGS); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 設定保存ダイアログ_書き込み設定値の取得
     * @returns 設定保存用書き込み設定値map
     */
    getSaveSettingsRequestBody() {
      // 現在選択されている値を取得する
      return this.cstmListItem.map(e => ({
        immutable_id: e.immuTableId,
        updateValue: resource.getCstmSettingValue(e.selectItem, e.mapKeyToValue)
      }));
    },

    /**
     * 設定保存ダイアログ_キャンセルボタン押下
     */
    cancelSaveSettings() {
      // ダイアログを閉じる
      this.modalSettingsSave = false;
    },

    /** 読み出し中ダイアログの表示 */
    showCustomReadModal() {
      this.modalCustomRead = true;
      // 設定読み出し一覧を取得
      this.showCustomReadList();
    },

    /** 検索の実行 */
    searchCustom() {
      // 選択中の解除
      this.selectedCustomRead = {};
      this.setHighLight();

      /** 検索入力値の取得 */
      const comment = this.filledComment.trim();

      // 検索条件でフィルター処理
      this.customReadTable = this.customReadTablePre;
      // 登録日（年）
      if (this.selectedYear !== '') {
        this.customReadTable = this.customReadTable.filter(item => new Date(item.registered_at).getFullYear() === Number(this.selectedYear));
      }
      // 登録日（月）
      if (this.selectedMonth !== '') {
        this.customReadTable = this.customReadTable.filter(item => new Date(item.registered_at).getMonth() + 1 === Number(this.selectedMonth));
      }
      // 説明
      if (comment !== '') {
        this.customReadTable = this.customReadTable.filter(item => item.description && item.description.indexOf(comment) !== -1);
      }
    },

    /** 設定一覧取得 */
    async showCustomReadList() {
      try {
        this.processing = true;

        // 設定読み出し一覧をマスター・ミラー両方から取得
        const { customizeHistories, validateErrorResult, hasUnexpectedError } =
          await fetchMasterMirrorCustomizeHistories(
            this,
            this.netAppId,
            individualDiagnose.getCurrentSystemId(this),
          );
        if (validateErrorResult) {
          this.validateErrorResult(validateErrorResult, VEHICLE_READ_HISTORY);
        } else if (hasUnexpectedError) {
          this.showUnexpectedError(VEHICLE_READ_HISTORY);
        }

        if (customizeHistories?.length > 0) {
          // 成功有無に関わらず、結果が得られた場合はテーブルデータを更新する
          customizeHistories.forEach((cstm) => {
            // unix時刻を文字列に変換する
            cstm.registered_at = util.timeConverter(cstm.registered_at);
            // 削除ボタンを設定する
            cstm.buttonVisible = true;
          });
          this.customReadTable = customizeHistories;
          this.customReadTablePre = this.customReadTable;
          this.searchCustom();
        }
      } finally {
        this.processing = false;
      }
    },

    /** 行選択 */
    clickRow(selected) {
      this.selectedCustomRead = selected;
      this.setHighLight();
    },

    /** 選択している機能のハイライト設定 */
    setHighLight() {
      this.customReadTable.forEach((item) => {
        if (item === this.selectedCustomRead) {
          item.fieldSpec = {
            registered_at: config.LIST_ITEM_HIGHLIGHT,
            description: config.LIST_ITEM_HIGHLIGHT,
          };
        } else if (item.fieldSpec) {
          delete item.fieldSpec;
        }
      });
    },

    /**
     * 削除ボタン押下処理
     * @param {object} selected 選択されている設定値
     */
    async delCustomReadList(selected) {
      try {
        this.processing = true;

        const { validateErrorResult, hasUnexpectedError } =
          await deleteCustomizeHistory(
            this,
            this.netAppId,
            individualDiagnose.getCurrentSystemId(this),
            selected.id,
            selected.region_info,
          );
        if (validateErrorResult) {
          this.validateErrorResult(validateErrorResult, VEHICLE_DELETE_HISTORY);
        } else if (hasUnexpectedError) {
          this.showUnexpectedError(VEHICLE_DELETE_HISTORY);
        } else {
          // 正常終了の場合、再読み込みで削除せず、表示上削除することで、APIを呼び出す手間を省く
          this.customReadTable = this.customReadTable.filter(
            (item) => item !== selected,
          );
          this.customReadTablePre = this.customReadTable;

          // 選択中の行が削除された場合、選択状態を解除する
          if (selected === this.selectedCustomRead) {
            this.selectedCustomRead = {};
          }
        }
      } finally {
        this.processing = false;
      }
    },

    /** 読み出し中ダイアログ_キャンセルボタン押下 */
    cstmReadClose() {
      // 読み出し中ダイアログを閉じる
      this.modalCustomRead = false;
    },

    /** 読み出し中ダイアログ_読み出しボタン押下 */
    updCustomData() {
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const failedReadSettingNames = [];
      // 読み出し設定値の更新
      const setting = this.selectedCustomRead.settings;
      setting.map((setting) => {
        const targetItem = this.cstmListItem.find(item => item.immuTableId === setting.immutable_id);
        if (!targetItem) {
          // サポートされておらず保存された項目が非表示のケースがある。その場合は、反映をスキップする。
          return;
        }
        const settingValue = resource.convertCstmDisplayItemNoDefault(targetItem.did, setting.updateValue, systemId, this);
        if (settingValue === '') {
          // 値が見つからない場合（新バージョンのマスターで保存された設定値が旧バージョンのミラーにない等）は、失敗一覧に記憶する
          failedReadSettingNames.push(targetItem.name);
        } else {
          targetItem.selectItem = settingValue;
        }
      });

      this.modalCustomRead = false;

      if (failedReadSettingNames.length > 0) {
        // 失敗一覧に項目がある場合のみ、ダイアログを表示する
        const failedSettingNames = [...new Set(failedReadSettingNames)].join('<br/>');
        const warningMessage = this.$t('individual.alert_cstm_read_settings_missing_values', [failedSettingNames]);
        alert.showWarning(this, null, warningMessage, () => { });
      }
    },

    /**
     * 呼び出し時のコンポーネント内ガードの共通処理
     * @param vm 呼び出し元のオブジェクト(this)
     * @param from 遷移元 
     */
    beforeRouteProcess(vm, from) {
      if (util.isFromSettingsPage(from.name) || util.isSameSystemPage(from)) {
        // 単位設定画面またはパスワード変更画面からの遷移時、または同じシステム内の子機能間への遷移の場合 trueを指定
        vm.isUseCache = true;
      } else {
        // 上記以外の場合、falseを指定
        vm.isUseCache = false;
      }
    },

    /**
     * 仕向地設定モーダルのヘッダカラー
     */
    destinationHeaderColor() {
      switch (this.setDestinationPhase) {
        case DESTINATION_PHASE.RECONFIRMATION:
          return "warning";
        case DESTINATION_PHASE.CONFIRMATION:
        case DESTINATION_PHASE.INPUT_CODE:
        default:
          return "secondary";
      }
    },

    /**
     * 仕向地設定モーダルの表示文言
     */
    destinationMessage() {
      const messageMap = {
        confirmation: `${this.confirmationDestination}`,
        inputCode: 'individual.label_cst_input_destination',
        reconfirmation: `${this.reconfirmationDestination}`
      };
      switch (this.setDestinationPhase) {
        case DESTINATION_PHASE.INPUT_CODE:
          return this.$t(messageMap[this.setDestinationPhase]);
        case DESTINATION_PHASE.CONFIRMATION:
        case DESTINATION_PHASE.RECONFIRMATION:
          return messageMap[this.setDestinationPhase];
        default:
          break;
      }
      return '';
    },

    /**
     * 仕向地設定処理 (メニューサポート呼び出し～データ読出し)
     */
    async destinationSettingRead() {
      try {
        const systemId = individualDiagnose.getCurrentSystemId(this);
        this.processing = true;
        this.isLoading = true;
        let messages = null;
        this.measuredId = null;

        // メニューサポート読出し
        const resMenuSupport = await this.postMenuSupport(systemId);
        if (resMenuSupport.status === null) { return; }
        if (resMenuSupport.isFailed) {
          // 異常終了している ⇒ アラートを表示してカスタマイズ情報を取得する
          messages = this.$t('individual.error_cstm_destination_get');
          alert.showError(this, null, messages, () => { this.getCstmsTable(); });
          return;
        }
        if (!resMenuSupport.status) {
          // 条件と一致していない ⇒ カスタマイズ情報を取得する
          await this.getCstmsTable();
          return;
        }

        // データ読出し
        const readCondition = await this.postReadDestinationSetting(systemId);
        if (readCondition.status === null) { return; }
        if (readCondition.status) {
          // 指定された遷移を行う
          switch (readCondition.transition) {
            case TRANSITION.TRANSITION_CONFIRMATION:
              // データ読出しで取得したデータに応じて表示内容設定
              this.currentDestination = readSetDestination(readCondition.destination, systemId, this);

              // 仕向地変更確認画面の表示内容を設定
              this.confirmationDestination = this.$t('individual.label_cst_current_destination').replace('$DID$', this.currentDestination);
              // 仕向地変更再確認画面の表示内容を設定
              this.reconfirmationDestination = this.$t('individual.label_cst_incorrect_destination').replace('$DID$', this.currentDestination);
              break;

            case TRANSITION.TRANSITION_GET_INFORMATION:
            default:
              // カスタマイズの取得を行う
              await this.getCstmsTable();
              return;
          }
        } else {
          // アラートを表示してカスタマイズ情報を取得する
          messages = this.$t('individual.error_cstm_destination_get');
          alert.showError(this, null, messages, async () => { await this.getCstmsTable(); });
          return;
        }

        // 設定値が取得できたら仕向地変更確認画面を表示
        this.showSetDestination = true;

      } finally {
        this.processing = false;
        this.isLoading = false;
      }
    },

    /**
     * 仕向地設定処理 (データ書込み～サポートDID読出し)
     */
    async destinationSettingUpdate() {
      try {
        const systemId = individualDiagnose.getCurrentSystemId(this);
        this.isLoading = true;
        this.measuredId = null;

        // データ書込み
        const updateCondition = await this.postWriteDestinationSetting(systemId);
        if (updateCondition === null) { return; }
        if (!updateCondition) {
          this.showUnexpectedError(VEHICLE_DESTINATION_SAVE);
          return;
        }

        // サポートDID読出し
        if (!await this.readSupportDid(systemId)) {
          return;
        }

        // カスタマイズ情報取得中画面に遷移
        // ※カスタマイズデータ取得処理を実行
        this.getCstmsTable();

      } finally {
        this.isLoading = false;

        // サポートDID読出しが完了したらモーダルを非表示にする
        this.showSetDestination = false;
        // 初期値を設定しておく
        this.setDestinationPhase = DESTINATION_PHASE.CONFIRMATION;
        this.inputDestinationCode = '';
        this.tmpRequestId = '';
      }
    },

    /**
     * メニューサポートを取得する
     * @param {string} systemId 現在のECU名
     * @returns {object} getMatchCondition()の返却値
     */
    async postMenuSupport(systemId) {
      const requestBody = {
        type: DESTINATION_TYPE.READ_MENU
      };

      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await executePolling(
        this,
        // POST API 呼び出しのコールバック
        async () => {
          return await apiService.postCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting',
            requestBody
          );
        },
        // GET API 呼び出しのコールバック
        async (postApiResponse) => {
          return await apiService.getCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_GET);
        },
        // POST API レスポンスチェックのコールバック
        (postApiResponse) => {

          // リクエストID が正常に返ってきたら成功とする
          if (postApiResponse?.data?.request_id) {
            // 次処理で使用したいためrequest_idを控える
            this.tmpRequestId = postApiResponse.data.request_id;
            return "";
          }

          logWrapper.log("request_id is not found in response.", postApiResponse?.data, true);
          return "PostResponseError";
        },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          switch (getApiResponse?.data?.status) {
            case REQUEST_STATUS_COMPLETED:
            case REQUEST_STATUS_IN_PROGRESS:
              // ポーリング続行・終了はそのまま返す
              return getApiResponse.data.status;
            case REQUEST_STATUS_FAILED:
            default:
              // それ以外はログを出した上で、エラーを返す
              logWrapper.log("get response is invalid.", getApiResponse?.data, true);
              return "GetResponseError";
          }
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
      );

      let res = {
        status: null
      };

      if (response) {
        const isMatch = await this.getMatchCondition(systemId);
        res = isMatch;
        return res;
      }
      return res;
    },

    /**
     * [UI.EXE.CST.RD.BIU.1]の実行条件を満たしているか確認する
     * @param {string} systemId 現在のECU名
     * @returns {object} res
     * @property {boolean} isFailed CC結果が異常終了している場合はtrue
     * @property {boolean} status [UI.EXE.CST.RD.BIU.1]の実行条件を満たしている場合はtrue
     */
    async getMatchCondition(systemId) {
      // Get APIを呼び出す
      const response = await executeSyncRequest(
        this,
        async () => {
          return await apiService.getParamCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting/' + this.tmpRequestId,
            {
              type: DESTINATION_TYPE.READ_MENU
            }
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_GET);
        },
        undefined,
        // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
      );

      const res = {
        status: null
      };
      if (response) {
        switch (response.data.status) {
          case REQUEST_STATUS_COMPLETED:
            res.isFailed = false;
            res.status = response.data.match_result;
            break;

          case REQUEST_STATUS_FAILED:
          default:
            res.isFailed = true;
            res.status = response.data.match_result;
            break;
        }
      }
      return res;
    },

    /**
     * 仕向地設定の現在設定値を取得
     * @param {string} systemId 現在のECU名
     * @returns {object} getCurrentSettingValue()の返却値
     */
    async postReadDestinationSetting(systemId) {
      const requestBody = {
        type: DESTINATION_TYPE.READ
      };

      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await executePolling(
        this,
        // POST API 呼び出しのコールバック
        async () => {
          return await apiService.postCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting',
            requestBody
          );
        },
        // GET API 呼び出しのコールバック
        async (postApiResponse) => {
          return await apiService.getCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_GET);
        },
        // POST API レスポンスチェックのコールバック
        (postApiResponse) => {
          // リクエストID が正常に返ってきたら成功とする
          if (postApiResponse?.data?.request_id) {
            // 次処理で使用したいためrequest_idを控える
            this.tmpRequestId = postApiResponse.data.request_id;
            return "";
          }

          logWrapper.log("request_id is not found in response.", postApiResponse?.data, true);
          return "PostResponseError";
        },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          switch (getApiResponse?.data?.status) {
            case REQUEST_STATUS_COMPLETED:
            case REQUEST_STATUS_IN_PROGRESS:
              // ポーリング続行・終了はそのまま返す
              return getApiResponse.data.status;
            case REQUEST_STATUS_FAILED:
            default:
              // それ以外はログを出した上で、エラーを返す
              logWrapper.log("get response is invalid.", getApiResponse?.data, true);
              return "GetResponseError";
          }
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
      );

      let res = {
        status: null
      };
      if (response) {
        res = await this.getCurrentSettingValue(systemId);
      }
      return res;
    },

    /**
     * 仕向地設定の現在設定値を取得
     * @param {string} systemId 現在のECU名
     * @returns {object} res
     * @property {boolean} status 処理が成功しているか
     * @property {string} transition 次の処理画面
     * @property {string} destination 現在の仕向地
     */
    async getCurrentSettingValue(systemId) {
      // Get APIを呼び出す
      const response = await executeSyncRequest(
        this,
        async () => {
          return await apiService.getParamCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting/' + this.tmpRequestId,
            {
              type: DESTINATION_TYPE.READ
            }
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_GET);
        },
        undefined,
        // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_GET); },
      );

      const res = {
        status: null
      };
      if (response) {

        switch (response.data.status) {
          case REQUEST_STATUS_COMPLETED:
            switch (response.data.user_data.transition) {
              case TRANSITION.TRANSITION_CONFIRMATION:
                res.status = true;
                res.transition = TRANSITION.TRANSITION_CONFIRMATION;
                res.destination = response.data.user_data.destination;
                break;
              case TRANSITION.TRANSITION_GET_INFORMATION:
                res.status = true;
                res.transition = TRANSITION.TRANSITION_GET_INFORMATION;
                break;
              default:
                res.status = false;
                break;
            }
            break;

          case REQUEST_STATUS_FAILED:
          default:
            res.status = false;
            break;
        }
      }
      return res;
    },

    /**
     * 入力した仕向地コードを書き込む
     * @param {string} systemId 現在のECU名
     * @returns {boolean} getWriteDestinationSetting()の返却値
     */
    async postWriteDestinationSetting(systemId) {

      // 入力コードからDataRecordを作成
      const writeData = writeSetDestination(this.inputDestinationCode);

      const requestBody = {
        type: DESTINATION_TYPE.WRITE,
        input_code: writeData
      };

      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await executePolling(
        this,
        // POST API 呼び出しのコールバック
        async () => {
          return await apiService.postCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting',
            requestBody
          );
        },
        // GET API 呼び出しのコールバック
        async (postApiResponse) => {
          return await apiService.getCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_SAVE);
        },
        // POST API レスポンスチェックのコールバック
        (postApiResponse) => {
          // リクエストID が正常に返ってきたら成功とする
          if (postApiResponse?.data?.request_id) {
            // 次処理で使用したいためrequest_idを控える
            this.tmpRequestId = postApiResponse.data.request_id;
            return "";
          }

          logWrapper.log("request_id is not found in response.", postApiResponse?.data, true);
          return "PostResponseError";
        },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          switch (getApiResponse?.data?.status) {
            case REQUEST_STATUS_COMPLETED:
            case REQUEST_STATUS_IN_PROGRESS:
              // ポーリング続行・終了はそのまま返す
              return getApiResponse.data.status;
            case REQUEST_STATUS_FAILED:
            default:
              // それ以外はログを出した上で、エラーを返す
              logWrapper.log("get response is invalid.", getApiResponse?.data, true);
              return "GetResponseError";
          }
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_SAVE); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_SAVE); },
      );

      let res = null;
      if (response) {
        res = await this.getWriteDestinationSetting(systemId);
      }
      return res;

    },

    /**
     * 仕向地設定の現在設定値を更新
     * @param {string} systemId 現在のECU名
     * @returns {boolean} 処理成功している場合は true を返却する
     */
    async getWriteDestinationSetting(systemId) {

      // Get APIを呼び出す
      const response = await executeSyncRequest(
        this,
        async () => {
          return await apiService.getParamCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting/' + this.tmpRequestId,
            {
              type: DESTINATION_TYPE.WRITE
            }
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_SAVE);
        },
        undefined,
        // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_SAVE); },
      );

      let res = null;
      if (response) {
        switch (response.data.status) {
          case REQUEST_STATUS_COMPLETED:
            res = true;
            break;
          case REQUEST_STATUS_FAILED:
            res = false;
            break;
          default:
            break;
        }
      }
      return res;
    },

    /**
     * サポートDID読みだし
     * @param {string} systemId 現在のECU名
     * @returns {boolean} 処理成功している場合は true を返却する
     */
    async readSupportDid(systemId) {
      const requestBody = {
        type: DESTINATION_TYPE.SUPPORT_DID,
        use_cache: false
      };

      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await executePolling(
        this,
        // POST API 呼び出しのコールバック
        async () => {
          return await apiService.postCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/destinationSetting',
            requestBody
          );
        },
        // GET API 呼び出しのコールバック
        async (postApiResponse) => {
          return await apiService.getCall(
            apiService.CST,
            '/netApps/' + this.netAppId + '/systems/' + systemId + '/customize/requests/' + postApiResponse.data.request_id
          );
        },
        // エラー発生のコールバック
        (errorType) => {
          logWrapper.log("errorCallback called.", errorType, true);
          this.showUnexpectedError(VEHICLE_DESTINATION_SUPPORT_IDS);
        },
        // POST API レスポンスチェックのコールバック
        (postApiResponse) => {
          // リクエストID が正常に返ってきたら成功とする
          if (postApiResponse?.data?.request_id) {
            // 次処理で使用したいためrequest_idを控える
            this.tmpRequestId = postApiResponse.data.request_id;
            return "";
          }

          logWrapper.log("request_id is not found in response.", postApiResponse?.data, true);
          return "PostResponseError";
        },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          switch (getApiResponse?.data?.status) {
            case REQUEST_STATUS_COMPLETED:
            case REQUEST_STATUS_IN_PROGRESS:
              // ポーリング続行・終了はそのまま返す
              return getApiResponse.data.status;
            case REQUEST_STATUS_FAILED:
            default:
              // それ以外はログを出した上で、エラーを返す
              logWrapper.log("get response is invalid.", getApiResponse?.data, true);
              return "GetResponseError";
          }
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_SUPPORT_IDS); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, VEHICLE_DESTINATION_SUPPORT_IDS); },
      );

      let res = null;
      if (response) {
        res = true;
      }

      return res;
    },

    /**
     * 仕向地変更確認画面にてOK押下時の処理
     */
    onDestinationConfirmationOkClicked() {
      // 仕向地コード入力画面に遷移
      this.setDestinationPhase = DESTINATION_PHASE.INPUT_CODE;
    },

    /**
     * 仕向地コード入力画面にてOK押下時の処理
     */
    onDestinationInputOkClicked() {
      // 入力内容が入力制限を満たしているか確認する
      if (this.isDestinationInputCodeValidate()) {
        // 入力制限を満たしていたら入力内容をチェックする
        // パターン(英字のみ)
        const patternEn = new RegExp(/^[a-zA-Z]+$/);
        // 入力内容(1文字目)
        const input1stChar = this.inputDestinationCode.slice(0, 1);

        // 1文字目のチェック (1文字目が英字)ではない または 2文字未満
        if (!patternEn.test(input1stChar) || this.inputDestinationCode.length < 2) {
          this.inputDestinationCode = '';
          // 仕向地変更再確認画面に遷移
          this.setDestinationPhase = DESTINATION_PHASE.RECONFIRMATION;
        } else {
          // 入力された内容で設定値を更新する
          this.destinationSettingUpdate();
        }
      }
    },

    /**
     * 仕向地設定にてOK押下時の処理
     */
    onDestinationSettingOkClicked() {
      switch (this.setDestinationPhase) {
        case 'confirmation':
        case 'reconfirmation':
          this.onDestinationConfirmationOkClicked();
          break;
        case 'inputCode':
          this.onDestinationInputOkClicked();
          break;
        default:
          break;
      }
    },

    /**
     * 仕向地設定中にてキャンセル押下時
     */
    onDestinationSettingCancelClicked() {
      // モーダル非表示
      this.showSetDestination = false;
      // 初期値を設定しておく
      this.setDestinationPhase = DESTINATION_PHASE.CONFIRMATION;
      this.inputDestinationCode = '';
      this.tmpRequestId = '';
      // カスタマイズ情報取得中画面に遷移
      // ※カスタマイズデータ取得処理を実行
      this.getCstmsTable();
    },

    /**
     * 入力内容が入力制限を満たしているか確認する
     */
    isDestinationInputCodeValidate() {

      this.validateParam = undefined;

      // パターン(ASCII文字)
      const patternASCII = new RegExp(/^[\x21-\x7e\s]*$/);

      // 入力規則(制御文字を除くASCII文字)
      if (!patternASCII.test(this.inputDestinationCode)) {
        // 入力規則に沿っていない場合はアラートを表示する
        this.validateParam = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return false;
      }

      return true;
    }
  },

  /**
   * createdイベント
   */
  created() {
    // イベントログのページビューカウント
    eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_CST);
  },

  /**
   * mountedイベント
   */
  mounted() {
    this.mountedLogic();
  }
};